import { deleteApiCaller, getApiCaller, postFormDataApiCaller, putApiCaller, putFormDataApiCaller } from "../apiCaller";

export const addCategory = async (payload) => {
    // Check if payload is already FormData
    if (payload instanceof FormData) {
        const response = await postFormDataApiCaller("category/create", payload);
        return response;
    }

    // Convert payload to FormData
    const formData = new FormData();

    formData.append('title', payload.title);
    if (payload.description) {
        formData.append('description', payload.description);
    }
    formData.append('parentId', payload.parentId || '');
    formData.append('sequence', payload.sequence || '0');

    if (payload.image) {
        formData.append('image', payload.image);
    }

    const response = await postFormDataApiCaller("category/create", formData);
    return response;
}

export const getCategories = async (page, limit, search, tree = 'false', parentId = undefined) => {
    let url = `category/get-all?page=${page}&limit=${limit}&search=${search || ""}&tree=${tree}&includeHidden=true`;
    if (parentId !== undefined) {
        url += `&parentId=${parentId}`;
    }
    const response = await getApiCaller(url);
    return response;
}

export const getCategoriesDropdown = async (search) => {
    const response = await getApiCaller(`category/dropdown?search=${search || ""}`);
    return response;
}

export const getCategoryById = async (id) => {
    const response = await getApiCaller(`category/${id}`);
    return response;
}

export const getContentByCategoryId = async (id, page = 1, limit = 10) => {
    const response = await getApiCaller(`category/${id}/content?page=${page}&limit=${limit}&includeHidden=true`);
    return response;
}

export const getCategoryChildren = async (id) => {
    const response = await getApiCaller(`category/${id}/children`);
    return response;
}

export const getCategoryAncestors = async (id) => {
    const response = await getApiCaller(`category/${id}/ancestors`);
    return response;
}

export const updateCategory = async (id, payload) => {
    // Check if payload is already FormData
    if (payload instanceof FormData) {
        const response = await putFormDataApiCaller(`category/update/${id}`, payload);
        return response;
    }

    // Convert payload to FormData
    const formData = new FormData();

    formData.append('title', payload.title);
    if (payload.description) {
        formData.append('description', payload.description);
    }
    formData.append('parentId', payload.parentId || '');
    formData.append('sequence', payload.sequence || '0');

    if (payload.image) {
        formData.append('image', payload.image);
    }

    const response = await putFormDataApiCaller(`category/update/${id}`, formData);
    return response;
}

export const deleteCategory = async (id) => {
    const response = await deleteApiCaller(`category/delete/${id}`);
    return response;
}

export const categorySequence = async (payload) => {
    const response = await putApiCaller("category/sequence", payload);
    return response;
}

export const swapCategoryWithPage = async (payload) => {
    const response = await putApiCaller("category/swap-page", payload);
    return response;
}

